import React from "react";
import clsx from "clsx";
import {
  Grid,
  Box,
  Typography,
  Link,
  Checkbox,
  makeStyles
} from "@material-ui/core";
import { FormattedText } from "../common/FormattedText";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import OptimizedTooltip from "../common/OptimizedTooltip";

const useStyles = makeStyles(theme => ({
  driverRow: {
    width: "100%",
    margin: 0,
    borderBottom: "1px solid #eee !important",
    backgroundColor: "#f9f9f9",

    "& .MuiGrid-item": {
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      justifyContent: "flex-start"
    },

    "& .edit-remove-btns": {
      opacity: 0,

      "& button": {
        marginLeft: theme.spacing(1.5)
      }
    },

    "& .select-icon": {
      display: "none",
      marginLeft: theme.spacing(-1.5),
      "& svg": {
        color: "inherit"
      }
    },
    "& .selected + div": {
      paddingLeft: theme.spacing(0.75)
    },

    "&:hover, .selected": {
      "& > :last-of-type p": {
        opacity: 0,
        userSelect: "none"
      },
      "& > :nth-child(2)": {
        paddingLeft: theme.spacing(0.75)
      },

      "& .select-icon": {
        display: "block"
      },

      "& .person-icon": {
        display: "none"
      },

      "& .edit-remove-btns": {
        opacity: 1,
        transition: "opacity .0s"
      }
    }
  },
  borderTop: {
    borderTop: "1px solid #eee !important"
  },
  pr8px: {
    paddingRight: `${theme.spacing(1)}px !important`
  },
  personIcon: {
    color: theme.variables.rootColor
  },
  personIconActive: {
    color: theme.palette.primary.main
  }
}));

export default function ListViewItem({
  CustomIcon,
  label,
  getInfo,
  item,
  checkAssigned,
  isSelected,
  handleSelect,
  inputValue,
  handleEdit,
  handleDelete,
  editDisabled,
  index
}) {
  const classes = useStyles();

  return (
    <Box
      data-cy={`${label}-item`}
      component={Grid}
      container
      spacing={4}
      height={50}
      alignItems="center"
      position="relative"
      className={clsx(classes.driverRow, {
        [classes.borderTop]: index === 0
      })}
    >
      <Box
        component={Grid}
        display="flex"
        item
        xs={"auto"}
        className={clsx(classes.pr8px, { selected: isSelected })}
      >
        <Checkbox
          className={clsx("select-icon")}
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(item.id)}
        />
        <CustomIcon
          fontSize="small"
          className={clsx(classes.personIcon, "person-icon", {
            [classes.personIconActive]:
              checkAssigned && checkAssigned(getInfo(item, "id"))
          })}
          profile={item.profile}
        />
      </Box>

      <Grid
        item
        xs={label === "vehicle" ? 8 : 5}
        style={{ paddingRight: label === "vehicle" ? 4 : 16 }}
        className={classes.leftText}
      >
        <Typography variant="body2" noWrap>
          <FormattedText text={getInfo(item, "left-text")} query={inputValue} />
        </Typography>
      </Grid>

      <Box
        component={Grid}
        display="flex"
        justifyContent="flex-end"
        item
        xs={label === "vehicle" ? 2 : 5}
      >
        <Typography variant="body2" noWrap>
          <FormattedText
            text={getInfo(item, "right-text")}
            query={inputValue}
          />
        </Typography>

        {/* Edit/remove buttons */}
        <Box
          alignSelf="center"
          display="flex"
          alignItems="center"
          className="edit-remove-btns"
          position="absolute"
          my="auto"
          right={12}
        >
          <Link
            component="button"
            onClick={() => handleEdit(item)}
            tabIndex="-1"
            data-cy={`edit-${label}`}
            disabled={editDisabled}
          >
            <OptimizedTooltip
              placement="bottom"
              title={`Edit ${label} details`}
              enterDelay={200}
              enterNextDelay={200}
            >
              <EditIcon />
            </OptimizedTooltip>
          </Link>

          {handleDelete && (
            <Link
              component="button"
              onClick={() => handleDelete(item)}
              tabIndex="-1"
              data-cy={`delete-${label}`}
            >
              <OptimizedTooltip
                placement="bottom"
                title={`Delete ${label}`}
                enterDelay={200}
                enterNextDelay={200}
              >
                <DeleteIcon />
              </OptimizedTooltip>
            </Link>
          )}
        </Box>
      </Box>
    </Box>
  );
}
